<template>
  <div
    class="main"
    v-if="images.length > 0"
  >
    <main-slide-first
      v-bind:image="findImageByTag('slide-1')"
      v-on:scroll-to-second-slide="scrollScreenToSecondSlide()"
    ></main-slide-first>
    <main-slide-full-screen
      v-bind:image="findImageByTag('slide-2')"
      ref="main-page-second-slide"
    ></main-slide-full-screen>
    <main-slide-multiple-images
      v-bind:images="filterImagesByTag('slide-3')"
    ></main-slide-multiple-images>
    <main-slide-image-aside
      v-bind:image="findImageByTag('slide-4')"
    ></main-slide-image-aside>
    <main-slide-image-aside
      v-bind:image="findImageByTag('slide-5')"
    ></main-slide-image-aside>
    <main-slide-full-screen
      v-bind:image="findImageByTag('slide-6')"
    ></main-slide-full-screen>
    <main-slide-full-screen
      v-bind:image="findImageByTag('slide-7')"
      v-bind:background-color="'rgba(255, 255, 255, 0.5)'"
      v-bind:inverse-colors="true"
      v-bind:center-text="false"
    ></main-slide-full-screen>
  </div>
</template>

<script>
import MainSlideFirst from '../components/the-content/MainSlideFirst'
import MainSlideFullScreen from '../components/the-content/MainSlideFullScreen'
import MainSlideImageAside from '../components/the-content/MainSlideImageAside'
import MainSlideMultipleImages from '../components/the-content/MainSlideMultipleImages'
import ImageAsideSlide from '../components/the-content/utils/ImageAsideSlide'
import utils from './utils'

export default {
  name: 'MainPage',
  components: {
    MainSlideFirst,
    MainSlideFullScreen,
    MainSlideImageAside,
    MainSlideMultipleImages,
    ImageAsideSlide
  },
  data () {
    return {
      title: 'Ювелирная фирма «Стиль»',
      description:
        'Ювелирная фирма «Стиль» - производитель ювелирных изделий в ' +
        'Беларуси. На сайте представлен каталог золотых и серебряных ' +
        'украшений с ценами и фото.',
      images: [],
      imageForMetaUrl: utils.addDomainToPath(
        '/static/images/logo/logo-black-white-background-large.png'
      ),
      imageForMetaWidth: 1200,
      imageForMetaHeight: 1200
    }
  },
  metaInfo () {
    return {
      title: this.title,
      titleTemplate: null,
      link: this.linkMetaTags,
      meta: utils.getDefaultMetaTags({
        description: this.description,
        path: this.$router.resolve(this.$route).href,
        title: this.title,
        imageUrl: this.imageForMetaUrl,
        imageWidth: this.imageForMetaWidth,
        imageHeight: this.imageForMetaHeight
      })
    }
  },
  mounted () {
    this.getMainPageImages()
  },
  updated () {
    if (this.images.length > 0 && window['__PRERENDER_INJECTED']) {
      document.dispatchEvent(new Event('render-event'))
    }
  },
  computed: {
    linkMetaTags: function () {
      let links = []
      if (this.images.length > 0) {
        let mainImage = this.findImageByTag('slide-1')
        links.push({rel: 'preload', href: mainImage.image, as: 'image'})
      }
      return links
    }
  },
  methods: {
    getMainPageImages: function () {
      const uri = `${process.env.API_HOST}/api/v1/images/get-images-by-tags`
      this.$http
        .get(uri, {params: {include_tags: 'main-page'}})
        .then(response => { this.images = response.body })
    },
    findImageByTag: function (tag) {
      return this.images.find(function (image) {
        return image.tags.includes(tag)
      })
    },
    filterImagesByTag: function (tag) {
      return this.images.filter(function (image) {
        return image.tags.includes(tag)
      })
    },
    scrollScreenToSecondSlide: function () {
      let header = document.getElementById('js-the-header')
      const headerHeight = Math.ceil(header.getBoundingClientRect().height)
      let element = this.$refs['main-page-second-slide'].$el
      window.scrollTo({
        top: element.offsetTop - headerHeight,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .main {
    background-color: $default-background-color;
    display: block;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/MainPage.vue